import { localize } from 'vee-validate'

localize({
  ja: {
    messages: {
      email: '{_field_} は有効なメールアドレスではありません。',
    }
  }
})